export const gitCommit = 'd8df1643'
